// extracted by mini-css-extract-plugin
export default {"wrap":"NoResults_wrap__WTsFc"};